// src/components/RequireRole.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../services/firebase";
import { onAuthStateChanged } from "firebase/auth";

export default function RequireRole({ children, anyOf = ["manager","admin"] }) {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [allowed, setAllowed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    const unsub = onAuthStateChanged(auth, async (u)=>{
      if (!u) {
        setUser(null);
        setAllowed(false);
        setLoading(false);
        return;
      }
      setUser(u);
      try {
        // ⚠️ il faut que les règles Firestore autorisent ce read
        const snap = await getDoc(doc(db, "roles", u.uid));
        const roles = snap.exists() ? snap.data() : {};
        const ok = anyOf.some(r => roles[r]);
        setAllowed(ok);
      } catch (e) {
        // si permission denied, on bloque
        setAllowed(false);
      } finally {
        setLoading(false);
      }
    });
    return () => unsub();
  }, [anyOf]);

  if (loading) return <div className="py-5 text-center">Chargement…</div>;
  if (!user) {
    // 🔁 renvoie vers /login avec la page demandée
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!allowed) {
    // pas le bon rôle → on renvoie vers / (ou montre un 403 si tu préfères)
    return <Navigate to="/" replace />;
  }
  return children;
}
